import { useEffect, useRef } from 'react';
import screenfull from 'screenfull';

export default function useFullScreen(callback = () => {}, initial = false) {
	const savedCallback = useRef();
	const elementRef = useRef();

	const setFullscreen = () => {
		if (!elementRef.current || !screenfull.isEnabled) return;
		screenfull.request(elementRef.current);
	};

	useEffect(() => {
		savedCallback.current = callback;
	}, [callback]);

	useEffect(() => {
		if (!screenfull.isEnabled) return;
		const onChange = () => {
			if (!screenfull.isFullscreen) {
				savedCallback.current();
				window.scroll({ top: 0, behavior: 'smooth' });
			}
		};

		screenfull.on('change', onChange);

		return () => {
			screenfull.off('change', onChange);
		};
	}, []);

	useEffect(() => {
		initial && setFullscreen();
		// eslint-disable-next-line
	}, []);

	return {
		elementRef,
		isEnabled: screenfull.isEnabled,
		setFullscreen
	};
}
